import { Component, OnInit } from "@angular/core";

import { combineLatest, Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";

import { AktuelInstallationObserver } from "@e-forsyning/common/installation";
import { AktuelBrugersInstallationerObserver } from "@e-forsyning/common/installation";

import { AppVaelgInstallationViewModel } from "./app-vaelg-installation.view-model";

@Component({
    selector: "app-vaelg-installation",
    templateUrl: "./app-vaelg-installation.component.html",
    styleUrls: ["./app-vaelg-installation.component.scss"]
})
export class AppVaelgInstallationComponent implements OnInit {
    public vm$: Observable<AppVaelgInstallationViewModel>;
    constructor(
        private readonly aktuelBrugersInstallationerObserver: AktuelBrugersInstallationerObserver,
        private readonly aktuelInstallationObserver: AktuelInstallationObserver
    ) {}

    public ngOnInit(): void {
        const installationer$ = this.aktuelBrugersInstallationerObserver.valueChanges;
        const aktuelInstallation$ = this.aktuelInstallationObserver.valueChanges;
        this.vm$ = combineLatest([installationer$, aktuelInstallation$]).pipe(
            map(([installationer, aktuelInstallation]) => ({
                adresse: (aktuelInstallation && aktuelInstallation.adresse) || "",
                maalerNr: (aktuelInstallation && aktuelInstallation.maalerNr) || "",
                vaelgInstallationHref: installationer && installationer.length > 1 ? "#/install-picker" : ""
            })),
            startWith({ adresse: "", maalerNr: "", vaelgInstallationHref: "" })
        );
    }

    public onLinkClick(event: MouseEvent, href: string): void {
        if (!href) {
            event.preventDefault();
        }
    }
}
